module.exports = __webpack_public_path__ + "img/persona_01.e45066be.jpg";